/**
 * В Telegram WebView асинхронный Clipboard API доступен не всегда: старые
 * версии клиента и обычный http-контекст его не дают. Поэтому основной путь —
 * `navigator.clipboard`, запасной — скрытое поле и `execCommand('copy')`.
 */
export async function copyText(value: string): Promise<boolean> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // Разрешение не выдано или контекст небезопасный — пробуем запасной путь.
    }
  }

  return copyWithSelection(value);
}

function copyWithSelection(value: string): boolean {
  const field = document.createElement('textarea');
  field.value = value;
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.top = '-1000px';
  field.style.opacity = '0';
  document.body.append(field);

  try {
    field.select();
    field.setSelectionRange(0, value.length);
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    field.remove();
  }
}
